import { PageContainer } from "./PageContainer";
import { ReactNode } from "react";
import { ArticleModalProvider } from "../providers/ArticleModalProvider";
import Lenis from "lenis/react";
import { RegionMapper } from "../providers/RegionMapper";

export const PageProviders = ({ children }: { children: ReactNode }) => (
  <RegionMapper>
    <Lenis root options={{ duration: 2 }}>
      <ArticleModalProvider />
      <PageContainer>{children}</PageContainer>
    </Lenis>
  </RegionMapper>
);
